export const API_URL = 'https://arabica-api.midadworld.com/api'
